import LeagueStanding from "./LeagueStanding";
import LeagueStandingCup from "./LeagueStandingCup";
import PageTabs from "./PageTabs";

export const FIFA_WORLD_CUP_LEAGUE_SLUG = "fifa-world-cup";

export default function LeagueStandingTotal({ league, standingsRes }) {
  if (!standingsRes) return null;

  const isCup =
    Array.isArray(standingsRes.roundScoreItems) &&
    standingsRes.roundScoreItems.length > 0;
  const colorInfos = standingsRes?.colorInfos || [];
  const totalStandings = standingsRes?.totalStandings || [];
  const awayStandings = standingsRes?.awayStandings || [];
  const homeStandings = standingsRes?.homeStandings || [];
  const isWorldCup = league?.slug === FIFA_WORLD_CUP_LEAGUE_SLUG;

  if (isCup) {
    return (
      <div className="space-y-3">
        <LeagueStandingCup
          roundScoreItems={standingsRes.roundScoreItems}
          isWorldCup={isWorldCup}
        />
      </div>
    );
  }

  if (totalStandings.length === 0) return null;

  return (
    <div className="space-y-3">
      <PageTabs
        key={league?.id}
        tabs={[
          {
            id: "bxhchung",
            label: "Tổng quan",
            content: (
              <LeagueStanding standings={totalStandings} colorInfos={colorInfos} />
            ),
          },
          {
            id: "sannha",
            label: "Sân Nhà",
            content: (
              <LeagueStanding standings={homeStandings} colorInfos={colorInfos} />
            ),
          },
          {
            id: "sankhach",
            label: "Sân Khách",
            content: (
              <LeagueStanding standings={awayStandings} colorInfos={colorInfos} />
            ),
          },
        ]}
        defaultTab="bxhchung"
      />
    </div>
  );
}
